import { render, staticRenderFns } from "./TQMHCHTTemplate.vue?vue&type=template&id=4684e6ff&scoped=true"
import script from "./TQMHCHTTemplate.vue?vue&type=script&lang=js"
export * from "./TQMHCHTTemplate.vue?vue&type=script&lang=js"
import style0 from "./TQMHCHTTemplate.vue?vue&type=style&index=0&id=4684e6ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4684e6ff",
  null
  
)

export default component.exports